// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1qokA","label":"Labeled_label__3KTKU","divider":"Labeled_divider__22cLp"};